import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { DropdownThreeDotsButton } from '@hivebrite/design-system/Dropdown';

import ShareContentModal from 'hb-react/frontoffice/components/ShareContentModal';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

const ReactionsSharesDropdown = ({
  content,
  onShareExternally,
  shareToLiveFeedEnabled,
  shareToLiveFeedUrl,
  shareUrl,
  sharedFrom,
  sharedUrl,
  children,
}) => {
  const { currentUser } = useDefaultAppContexts();

  const [shareModalOpen, setShareModalOpen] = useState(false);

  const {
    data: {
      options: sharingOptions,
      userTargetingNetwork,
      userTargetingTopics,
    } = {},
    isLoading: sharingOptionsLoading,
  } = useQuery({
    queryKey: ['share_to_live_feed_options', currentUser?.id],
    queryFn: () =>
      axios
        .get(Routes.user_sharing_options_path(currentUser.id))
        .then((res) => res.data),
    enabled: Boolean(currentUser && shareToLiveFeedEnabled),
    staleTime: 30000, // 30 seconds - Avoid requests for every items on the page
  });

  if (sharingOptionsLoading) {
    return null;
  }

  const buttonProps = shareUrl && {
    as: 'a',
    href: shareUrl,
    'data-bypass-router': true,
  };

  const items = [
    sharingOptions?.length > 0 && content && sharedFrom && sharedUrl
      ? {
          label: __('Share on Livefeed'),
          onClick: () => setShareModalOpen(true),
        }
      : null,
    onShareExternally
      ? {
          label: __('Share externally'),
          onClick: () => {
            if (shareUrl) {
              window.location.href = shareUrl;
            }
            onShareExternally();
          },
          buttonProps, // TODO -> Find wayt to bring those props onto the button in the DropdownItem
        }
      : null,
  ].filter(Boolean);

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      {items.length === 1 ? (
        children({ onClick: items[0].onClick, ...buttonProps })
      ) : (
        <DropdownThreeDotsButton
          dataTestId="reaction-share-dropdown"
          items={items}
          position="right"
        />
      )}
      {shareModalOpen && (
        <ShareContentModal
          onClose={() => setShareModalOpen(false)}
          content={content}
          sharingOptions={sharingOptions}
          shareToLiveFeedUrl={shareToLiveFeedUrl}
          sharedFrom={sharedFrom}
          sharedUrl={sharedUrl}
          userTargetingNetwork={userTargetingNetwork}
          userTargetingTopics={userTargetingTopics}
        />
      )}
    </>
  );
};

ReactionsSharesDropdown.propTypes = {
  content: PropTypes.object,
  onShareExternally: PropTypes.func,
  shareToLiveFeedEnabled: PropTypes.bool,
  shareToLiveFeedUrl: PropTypes.string,
  shareUrl: PropTypes.string,
  sharedFrom: PropTypes.string,
  sharedUrl: PropTypes.string,
};

export default ReactionsSharesDropdown;
